import type { Rule } from 'antd/es/form';

/**
 * 用户名字段校验的**唯一来源**。
 *
 * 背景：注册页此前不限制最小长度，登录页却要求 `min: 3`，管理端新建用户又限制
 * `max: 30`——三处口径各不相同，且与后端不一致，表现为「注册能过、登录却报
 * 至少 3 个字符」以及「管理端建不出后端允许的长用户名」。
 *
 * 后端口径（jupyter-go）：`loginRequest` / `registerRequest` / `adminUserCreateRequest`
 * 统一为 `required,min=1,max=150`，`account_user.username` 列宽 size:150。
 */
export const USERNAME_MIN_LENGTH = 1;
export const USERNAME_MAX_LENGTH = 150;

/** 允许字符：字母、数字、下划线、点、@、加号、减号（与注册历史规则 `[\w.@+-]` 等价）。 */
export const USERNAME_PATTERN = /^[A-Za-z0-9_.@+-]+$/;
export const USERNAME_PATTERN_MESSAGE = '用户名只能包含字母、数字和 _ . @ + -';

export interface UsernameRuleOptions {
  /** 是否必填，默认 true */
  required?: boolean;
  /**
   * 是否校验长度与字符集，默认 true。
   * 登录页传 false：历史账号可能含其他字符，登录应尽量放行，把最终判定交给后端。
   */
  withFormat?: boolean;
}

/** 用户名表单规则（注册 / 新建用户 / 编辑用户 / 登录共用）。 */
export function usernameRules(options: UsernameRuleOptions = {}): Rule[] {
  const { required = true, withFormat = true } = options;
  const rules: Rule[] = [];
  if (required) {
    rules.push({ required: true, message: '请输入用户名' });
  }
  if (withFormat) {
    rules.push({ max: USERNAME_MAX_LENGTH, message: `用户名不能超过 ${USERNAME_MAX_LENGTH} 个字符` });
    rules.push({ pattern: USERNAME_PATTERN, message: USERNAME_PATTERN_MESSAGE });
  }
  return rules;
}

/** 登录专用：只要求非空，长度/字符集交给后端（兼容历史账号）。 */
export function loginUsernameRules(): Rule[] {
  return usernameRules({ withFormat: false });
}
